import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import api from 'services';

import MergingAreas from './Areas';
import MergingPorts from './Ports';

import { addNotification } from 'actions/notifications/notifications';
import { updateArea } from 'actions/regions/areas';

import { execute } from 'store/configureStore';
import { getAreas } from 'sagas/regions/areas';
import { getPorts } from 'sagas/regions/ports';

import MergeErrorDialog from './MergeErrorDialog';

class MergingPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            sourceArea: {},
            destinationArea: {},

            sourcePort: {},
            destinationPort: {},

            disabledMergeAreas: true,
            disabledMergePorts: true,
            disableAddAreaToArea: true,

            clearAreas: false,
            clearPorts: false,
            errorAltNames: [],
            isMergeErrorOpened: false,
        };

        this.mergePorts = this.mergePorts.bind(this);
        this.mergeAreas = this.mergeAreas.bind(this);
        this.joinAreas = this.joinAreas.bind(this);
        this.addAreaToArea = this.addAreaToArea.bind(this);
        this.addValue = this.addValue.bind(this);
    }

    checkForUpdate() {
        if (this.state.sourceArea._id && this.state.destinationArea._id) {
            this.setState({
                disabledMergeAreas: false,
                disableAddAreaToArea: false,
            });
        } else {
            this.setState({
                disabledMergeAreas: true,
                disableAddAreaToArea: true,
            });
        }

        if (this.state.sourcePort._id && this.state.destinationPort._id) {
            this.setState({
                disabledMergePorts: false,
            });
        } else {
            this.setState({
                disabledMergePorts: true,
            });
        }
    }

    addValue(type, valueObject) {
        this.setState({
            [type]: valueObject,
        }, () => {
            this.checkForUpdate();
        });
    }

    mergePorts() {
        this.setState({
            disabledMergePorts: true,
        }, () => {
            api.mergeAreaOrPortToPort(this.state.destinationPort._id, this.state.sourcePort._id)
                .then(response => this.setState({
                    sourcePort: {},
                    destinationPort: {},
                    disabledMergePorts: true,
                    clearPorts: true,
                }, () => {
                    this.props.addNotification({
                        title: 'Success',
                        message: response.data.data.message,
                        level: 'success',
                        _id: new Date(),
                        autoDismiss: 2,
                    });

                    this.setState({
                        clearPorts: false,
                    }, () => {
                        if (this.props.createNewArea) {
                            this.updateAreasAndPorts();
                        }
                    });
                }))
                .catch((error) => {
                    this.setState({
                        disabledMergePorts: false,
                    }, () => {
                        this.props.addNotification({
                            title: 'Error',
                            message: error.response.data.errors[0].messages[0],
                            level: 'error',
                            _id: new Date(),
                            autoDismiss: 10,
                        });
                    });
                });
        });
    }

    async updateAreas() {
        await execute(getAreas);

        this.props.createNewArea();
    }

    async updateAreasAndPorts() {
        await execute(getAreas);
        await execute(getPorts);

        this.props.createNewArea();
    }

    mergeAreas() {
        this.setState({
            disabledMergeAreas: true,
        }, () => {
            api.mergeAreaToArea(this.state.destinationArea._id, this.state.sourceArea._id)
                .then(response => this.setState({
                    sourceArea: {},
                    destinationArea: {},
                    disabledMergeAreas: true,
                    clearAreas: true,
                }, () => {
                    this.props.addNotification({
                        title: 'Success',
                        message: response.data.data.message,
                        level: 'success',
                        _id: new Date(),
                        autoDismiss: 2,
                    });

                    this.setState({
                        clearAreas: false,
                        errorAltNames: [],
                    }, () => {
                        if (this.props.createNewArea) {
                            this.updateAreas();
                        }
                    });
                }))
                .catch((error) => {
                    this.setState({
                        disabledMergeAreas: false,
                    }, () => {
                        const message = error.response.data.errors[0].messages[0];
                        this.props.addNotification({
                            title: 'Error',
                            message,
                            level: 'error',
                            _id: new Date(),
                            autoDismiss: 10,
                        });
                        if (/area already exists with this alt names/i.test(message)) {
                            let errorAltNames = [];

                            if (error.response.data.names) {
                                errorAltNames = error.response.data.names
                                    .map(n => n.toLowerCase());
                            }

                            this.setState({
                                errorAltNames,
                            });
                            this.handleMergeErrorOpened();
                        }
                    });
                });
        });
    }

    addAreaToArea() {
        this.props.updateArea({
            _id: this.state.destinationArea._id,
            name: this.state.destinationArea.name, // to show in the notification
            childs: [
                ...this.state.destinationArea.childs.map(item => item._id),
                this.state.sourceArea._id,
            ],
        });
    }

    joinAreas() {
        this.setState({
            disabledMergeAreas: true,
        }, () => {
            api.joinAreaToArea(this.state.destinationArea._id, this.state.sourceArea._id)
                .then(response => this.setState({
                    sourceArea: {},
                    destinationArea: {},
                    disabledMergeAreas: true,
                    clearAreas: true,
                }, () => {
                    this.props.addNotification({
                        title: 'Success',
                        message: response.data.data.message,
                        level: 'success',
                        _id: new Date(),
                        autoDismiss: 2,
                    });

                    this.setState({
                        clearAreas: false,
                    }, () => {
                        if (this.props.createNewArea) {
                            this.updateAreas();
                        }
                    });
                }))
                .catch((error) => {
                    this.setState({
                        disabledMergeAreas: false,
                    }, () => {
                        this.props.addNotification({
                            title: 'Error',
                            message: error.response.data.errors[0].messages[0],
                            level: 'error',
                            _id: new Date(),
                            autoDismiss: 10,
                        });
                    });
                });
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.area && nextProps.area._id && this.state.sourceArea._id !== nextProps.area._id) {
            api.findPortAdmin({ name: nextProps.area.name, onlyAreasWithChild: true })
                .then((response) => {
                    if (response.status === 200) {
                        let sourceObject = { name: '' };

                        response.data.data.forEach((item) => {
                            if (item._id === nextProps.area._id) {
                                sourceObject = item;
                            }
                        });

                        this.setState({
                            sourcePort: sourceObject,
                            sourceArea: sourceObject,
                        });
                    }
                });
        }
        // Clear sourceArea & destinationArea after update finishes
        if (nextProps.isUpdating !== this.state.isUpdating) {
            this.setState(state => ({
                isUpdating: nextProps.isUpdating,
                sourceArea: !nextProps.isUpdating ? {} : state.sourceArea,
                destinationArea: !nextProps.destinationArea ? {} : state.destinationArea,
                clearAreas: nextProps.isUpdating, // original hack to notify subcomponent
            }));
        }
    }

    handleMergeErrorOpened = () => {
        this.setState({
            isMergeErrorOpened: !this.state.isMergeErrorOpened,
        });
    }

    handleBypassError = async () => {
        try {
            const areaInfo = await api.getArea(this.state.destinationArea._id);
            if (areaInfo.status !== 200) {
                this.props.addNotification({
                    title: 'Error',
                    message: 'Destination area not found',
                    level: 'error',
                    _id: new Date(),
                    autoDismiss: 10,
                });
                return;
            }

            const updatedAltsArea = await api.updateAreaAlt({
                _id: this.state.destinationArea._id,
                alt: areaInfo.data.alt
                    .filter(a => !this.state.errorAltNames.includes(a.toLowerCase())),
            });

            if (updatedAltsArea.status !== 200) {
                this.props.addNotification({
                    title: 'Error',
                    message: updatedAltsArea.data.errors[0].messages[0],
                    level: 'error',
                    _id: new Date(),
                    autoDismiss: 10,
                });

                return;
            }

            this.mergeAreas();
            this.handleMergeErrorOpened();
        } catch (e) {
            this.props.addNotification({
                title: 'Error',
                message: 'Could not merge areas',
                level: 'error',
                _id: new Date(),
                autoDismiss: 10,
            });
        }
    }

    render() {
        const {
            disabledMergeAreas, disabledMergePorts, disableAddAreaToArea, clearAreas, clearPorts, 
            sourcePort, sourceArea, errorAltNames, isMergeErrorOpened, destinationArea,
        } = this.state;
        const { isUpdating } = this.props;
        const areaButtonsDisabled = !destinationArea._id || !sourceArea._id || isUpdating;
        return (
            <div id='merging' className='container' style={{ maxWidth: '100%' }}>
                <MergeErrorDialog 
                    errorAltNames={errorAltNames}
                    handleBypassError={this.handleBypassError}
                    handleMergeErrorOpened={this.handleMergeErrorOpened}
                    isMergeErrorOpened={isMergeErrorOpened}
                />
                <MergingAreas
                    mergeAreas={this.mergeAreas}
                    joinAreas={this.joinAreas}
                    addAreaToArea={this.addAreaToArea}
                    addValue={this.addValue}
                    disabledBtn={areaButtonsDisabled}
                    disabledAddAreaToArea={areaButtonsDisabled}
                    clearAreas={clearAreas}
                    sourceArea={sourceArea}
                />

                <MergingPorts
                    mergePorts={this.mergePorts}
                    addValue={this.addValue}
                    disabledBtn={disabledMergePorts}
                    clearPorts={clearPorts}
                    sourcePort={sourcePort}
                />
            </div>
        );
    }
}

export default connect(
    ({ user: { isLogged }, areas }, { area }) => ({
        isLogged,
        area,
        isUpdating: areas.isUpdating,
    }),
    dispatch => bindActionCreators(
        {
            addNotification,
            updateArea,
        },
        dispatch, 
    ),
)(MergingPage);



// WEBPACK FOOTER //
// ./app/components/Regions/Merging/Page.jsx